const btnDirective = {};

const throttle = (fn, wait = 500) => {
  let last = 0
  return function () {
    let now = Date.now()
    if (now - last > wait) {
      fn.apply(this, arguments)
      last = now
    }
  }
}
const debounce = (fn, wait = 500) => {
  let timer = null
  return function () {
    let now = !timer
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      timer = null
    }, wait)
    if (now) {
      fn.apply(this, arguments)
    }
  }
}

btnDirective.install = Vue => {
  // 注册全局节流指令
  Vue.directive('throttle', {
    bind(el, binding) {
      let executeFunction
      if (binding.value instanceof Array) {
        const [func, timer] = binding.value;
        executeFunction = throttle(func, timer);
      } else {
        console.error(`throttle指令绑定的参数必须是数组，且需执行的事件类型或函数或时间间隔不能为空`)
        return
      }
      el.addEventListener('click', executeFunction);
    }
  })

  // 注册全局防抖指令
  Vue.directive('debounce', {
    bind(el, binding) {
      let executeFunction
      if (binding.value instanceof Array) {
        const [func, timer] = binding.value;
        executeFunction = debounce(func, timer);
      } else {
        console.error(`debounce指令绑定的参数必须是数组，且需执行的事件类型或函数或时间间隔不能为空`)
        return
      }
      el.addEventListener('click', executeFunction);
    }
  })
  // el-select滚动加载
  Vue.directive("loadmore", {
    bind(el, binding) {
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector(
        ".el-select-dropdown .el-select-dropdown__wrap"
      );
      SELECTWRAP_DOM.addEventListener("scroll", function() {
        const CONDITION =
          this.scrollHeight - this.scrollTop <= this.clientHeight;
        if (CONDITION) {
          binding.value();
        }
      });
    }
  });
};

export default btnDirective;



// WEBPACK FOOTER //
// ./packages/SrDirectives/index.js